import { z } from "zod";

// const MAX_SIZE = 2 * 1024 * 1024; // 2MB

/**
 * =========================
 * User Signup Validation
 * =========================
 */
export const signupSchema = z.object({
  gstNumber: z
    .string()
    .regex(
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
      "Invalid GST number",
    )
    .optional()
    .or(z.literal("")),
  companyName: z.string().nonempty("Company name is required"),
  companyAddress: z.string().optional(),
  companyLogo: z.string().optional(),
  natureOfBusiness: z.string().optional(),
  contactPerson: z.string().optional(),

  phone: z
    .string()
    .nonempty("Phone number is required")
    .regex(/^[6-9]\d{9}$/, "Invalid phone number"),

  email: z
    .string()
    .nonempty("Email ID is required")
    .refine((val) => !val || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val), {
      message: "Invalid email address",
    }),

  // kycDocuments: z
  //   .array(z.instanceof(File))
  //   .min(1, "KYC documents are required")
  //   .max(2, "Maximum 2 files allowed")
  //   // per-file size
  //   .refine(
  //     (files) => files.every((f) => f.size <= MAX_SIZE),
  //     "Each file must be under 2MB",
  //   ),
});

export type SignupValues = z.infer<typeof signupSchema>;

export const signupDefaultValues: SignupValues = {
  companyName: "",
  gstNumber: "",
  companyAddress: "",
  companyLogo: "",
  natureOfBusiness: "",
  contactPerson: "",
  phone: "",
  email: "",
};

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

export const ALLOWED_KYC_TYPES = ["application/pdf", "image/png", "image/jpeg"];

export function validateKycFiles(files: File[]) {
  if (!files || files.length === 0) {
    throw new Error("KYC documents are required");
  }

  if (files.length > 2) {
    throw new Error("Maximum 2 KYC documents allowed");
  }

  for (const file of files) {
    if (file.size > MAX_FILE_SIZE) {
      throw new Error(`${file.name} exceeds 5MB limit`);
    }

    if (!ALLOWED_KYC_TYPES.includes(file.type)) {
      throw new Error(`${file.name} has invalid file type (${file.type})`);
    }
  }
}
